export class ListBillingTransactionHistoryResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "timeFrame",
            "baseName": "timeFrame",
            "type": "TimeFrame",
            "format": ""
        },
        {
            "name": "transactions",
            "baseName": "transactions",
            "type": "Array<BillingTransactionHistory>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListBillingTransactionHistoryResponse.attributeTypeMap;
    }
    constructor() {
    }
}
